import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './QuizPreview.css';
import {useProfile} from '../context/ProfileContext';
function QuizPreview() {
  const navigate = useNavigate();
  const location = useLocation();
    const { fetchNameWallet} = useProfile();
  // Log the entire location state for debugging
  
  
  const { answers, questions, match, isTimeout, amount, multiplier } = location.state || {};
  
  // Store and retrieve values from localStorage as a fallback
  useEffect(() => {
    // If we have valid values, store them in localStorage
    if (amount !== undefined) {
      localStorage.setItem('betAmount', amount);
    }
    if (multiplier !== undefined) {
      localStorage.setItem('betMultiplier', multiplier);
    }
  }, [amount, multiplier]);
  
  // Get values from localStorage as fallback
  const getAmount = useCallback(() => {
    if (amount !== undefined) return amount;
    const storedAmount = localStorage.getItem('betAmount');
    return storedAmount ? Number(storedAmount) : 0;
  }, [amount]);
  
  const getMultiplier = useCallback(() => {
    if (multiplier !== undefined) return multiplier;
    const storedMultiplier = localStorage.getItem('betMultiplier');
    return storedMultiplier ? Number(storedMultiplier) : 1;
  }, [multiplier]);
  
  // Log the extracted values
  // console.log("QuizPreview extracted values:", { 
  //   match, 
  //   multiplier: getMultiplier(), 
  //   amount: getAmount(), 
  //   answersLength: answers?.length,
  //   questionsLength: questions?.length
  // });
  
  const [selectedAnswers, setSelectedAnswers] = useState(answers || []);
  const [showScorePopup, setShowScorePopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  
  const handleConfirm = useCallback(async () => {
    try {
      setIsSubmitting(true);
      setSubmitError(null);

      // Get user data from localStorage
      const userString = localStorage.getItem('user');
      
      if (!userString) {
        alert('You must be logged in to place a bet');
        navigate('/login');
        return;
      }
      
      // Parse user data from localStorage
      let userData;
      try {
        userData = JSON.parse(userString);
      } catch (error) {
        console.error('Error parsing user data:', error);
        alert('Error with user session. Please log in again.');
        navigate('/login');
        return;
      }
      
      // Get userId from user data
      const userId = userData.id || userData._id || userData.userId;
      
      if (!userId) {
        alert('User ID not found. Please log in again.');
        navigate('/login');
        return;
      }
      
      // Get final amount and multiplier values
      const finalAmount = getAmount();
      const finalMultiplier = getMultiplier();
      
      if (!finalAmount || !finalMultiplier) {
        setSubmitError('Invalid bet amount or multiplier');
        return;
      }
      
      // Calculate potential profit
      const profit = finalAmount * finalMultiplier;
        
      // Prepare data to send to backend
      const quizData = {
        userId,
        matchId: match.matchId,
        questions: questions.map((question, index) => ({
          questionId: question.id || index,
          question: question.question,
          selectedOptionIndex: selectedAnswers[index],
          selectedOption: question.options[selectedAnswers[index]]
        })),
        totalScore: selectedAnswers.length,
        totalQuestions: questions.length,
        amount: finalAmount,
        multiplier: finalMultiplier,
        team1: match.team1,
        team2: match.team2,
        profit: profit,
        match: match.questions || [] // Include match questions if available
      };
      
      console.log("Submitting quiz data:", quizData);
      
      // Send data to backend
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/parleybet/4ka100quiz/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(quizData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit quiz');
      }
      
      const data = await response.json();
      console.log('Quiz submitted successfully:', data);
      fetchNameWallet();
      // Show score popup after successful submission
      setShowScorePopup(true);
    } catch (error) {
      console.error('Error submitting quiz:', error);
      setSubmitError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  }, [navigate, getAmount, getMultiplier, match, questions, selectedAnswers,fetchNameWallet]);

  useEffect(() => {
    // If this is a timeout, automatically confirm answers
    if (isTimeout) {
      handleConfirm();
    }
  }, [isTimeout, handleConfirm]);

  const handleOptionSelect = (questionIndex, optionIndex) => {
    const newAnswers = [...selectedAnswers];
    newAnswers[questionIndex] = optionIndex;
    setSelectedAnswers(newAnswers);
  };

  const handleBackToMainMenu = () => {
    navigate('/');
  };
  const handleBackToMainevent = () => {
    navigate('/');
  };


  const handleBackToQuestion = (index) => {
    console.log("QuizPreview handleBackToQuestion - passing back:", {
      amount: getAmount(),
      multiplier: getMultiplier()
    });
    
    navigate('/quiz', {
      state: {
        currentQuestionIndex: index,
        answers: selectedAnswers,
        match,
        questions,
        amount: getAmount(),
        multiplier: getMultiplier()
      }
    });
  };
  

  if (!selectedAnswers || !questions || !match) {
    return (
      <div className="preview-screen">
        <div className="error-message">
          <h2>Error: Missing Required Information</h2>
          <p>Could not load quiz preview. Please go back and try again.</p>
          <button 
            className="back-button"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  // const score = selectedAnswers.length;
  // const totalQuestions = questions.length;

  return (
    <div className="preview-screen">
      <div className="preview-container">
        <h2 className="preview-title">Review Your Answers</h2>
        {match && (
          <div className="match-info-preview">
            <h3>{match.team1} vs {match.team2}</h3>
            <p>{match.matchDate} | {match.matchTime}</p>
          </div>
        )}
        <div className="preview-content">
          {questions.map((question, questionIndex) => (
            <div key={questionIndex} className="preview-question">
              <div className="preview-question-header">
                <span className="question-number">Question {questionIndex + 1}</span>
                <button 
                  className="edit-button"
                  onClick={() => handleBackToQuestion(questionIndex)}
                >
                  Edit
                </button>
              </div>
              <div className="preview-question-text">{question.question}</div>
              <div className="preview-options-container">
                <div className="preview-options">
                  {question.options.map((option, optionIndex) => (
                    <div
                      key={optionIndex}
                      className={`preview-option ${selectedAnswers[questionIndex] === optionIndex ? 'selected' : 'notSelected'}`}
                      onClick={() => !isTimeout && handleOptionSelect(questionIndex, optionIndex)}
                    >
                      <div className="option-letter">{String.fromCharCode(65 + optionIndex)}</div>
                      <div className="option-text">{option}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="preview-actions">
          <button 
            className="back-button"
            style={{ width: '100%' }}
            onClick={() => handleBackToQuestion(questions.length - 1)}
          >
            Back to Quiz
          </button>
          <button 
            className="confirm-button"
            onClick={handleConfirm}
            style={{ width: '100%' }}
            disabled={isTimeout || isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Confirm Answers'}
          </button>
        </div>
        {submitError && (
          <div className="error-message">
            <p>{submitError}</p>
          </div>
        )}
      </div>

      {showScorePopup && (
        <div className="score-popup-overlay">
          <div className="score-popup">
            <h2 className="score-title">Quiz Submitted!</h2>
            <div className="score-details">
              {/* <p className="score-text">Your Score: {score} / {totalQuestions}</p> */}
              <p>Your answers have been submitted.</p>
            </div>
            <button 
              className="main-menu-button"
              onClick={handleBackToMainMenu}
              style={{marginBottom:'10px'}}
            >
              Back to Home 
            </button>
            <button 
              className="main-menu-button"
              onClick={handleBackToMainevent}
            >
              
             Back to Events
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default QuizPreview; 
